import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import striptags from 'striptags';
import reactHtmlParser from "react-html-parser";

import {deleteAnswers} from "scenes/Survey/Structure/data/answers/actions";

class CheckedDelete extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      deleting: false,
    };

    this.deleteChecked = this.deleteChecked.bind(this);
    this.toggleModalDelete = this.toggleModalDelete.bind(this);
  }

  deleteChecked(){
    this.setState({
      deleting: true
    });

    this.props.deleteAnswers(this.props.question.id, {
      ids: this.props.answersChecked.map(answer => answer.id)
    });
  }

  toggleModalDelete(){
    this.setState({ modal: !this.state.modal })
  }

  render() {
    const {answersChecked} = this.props;
    const {deleting} = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModalDelete()}>
      <ModalHeader toggle={() => this.toggleModalDelete()} tag="h2"><FormattedMessage id="answers.actions.checkedDelete.modalHeader"/></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="answers.actions.checkedDelete.modalBody"/>?</p>
        <ul>
          {answersChecked.map((answer, key) => {
            return <li key={key}><h4>{reactHtmlParser(striptags(answer.content))}</h4></li>
          })}
        </ul>
      </ModalBody>
      <ModalFooter>
        <div className="direction-group d-flex justify-content-end">
          <div className="direction-right">
            <FormattedMessage id="answers.actions.checkedDelete.button.confirmation">{
              (message) => <LaddaButton
                className="btn btn-danger btn-ladda mb-0 ml-3"
                loading={deleting}
                data-style={ZOOM_OUT}
                onClick={() => this.deleteChecked()}
              >
                {message}
              </LaddaButton>
            }</FormattedMessage>
            <FormattedMessage id="_.button.cancel">{
              (message) => <Button color="secondary" onClick={() => this.toggleModalDelete()} className="mb-0 ml-3">{message}</Button>
            }</FormattedMessage>
          </div>
        </div>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Label className="label-filtr bg-danger text-white" color="danger" onClick={() => this.toggleModalDelete()}><i className="fas fa-trash" /> <FormattedMessage id="answers.actions.checkedDelete.button"/> ({answersChecked.length})</Label>
        {modal}
      </React.Fragment>
    )
  }
}

CheckedDelete.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  answersChecked: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired).isRequired
};


export default connect(null, {deleteAnswers})(CheckedDelete);